import React from 'react';
import { Download, HeadsetHelp } from 'iconoir-react';
import type { SessionScreen } from '../../../features/flow/session';
import type { ScreenQuestion } from '../../../features/flow/types';
import { cleanTitle } from '../../../features/flow/utils';

export function SubmissionSuccessDownloadsScreenBody({
  sessionScreen,
  questions,
  onContactUs,
}: {
  sessionScreen: SessionScreen;
  questions: ScreenQuestion[];
  onContactUs?: () => void;
}) {
  const title = cleanTitle(sessionScreen.title ?? '');
  const paragraphs = Array.isArray(sessionScreen.paragraphs) ? sessionScreen.paragraphs.filter((p) => String(p).trim() !== '') : [];

  const actionQ = questions.find((q) => q.field_type === 'action_buttons');
  const actions = Array.isArray(actionQ?.options) ? actionQ!.options.map(String) : [];

  return (
    <div className="w-full min-h-[520px] flex flex-col items-center text-center gap-8">
      <div className="w-full flex flex-col items-start gap-4 shrink-0">
        <h1 className="text-lg md:text-[22px] lg:text-2xl font-medium md:font-semibold text-[#131315]">{title}</h1>
        {paragraphs.length > 0 ? (
          <div className="w-full max-w-[520px] flex flex-col items-start text-start gap-1.5">
            {paragraphs.map((p) => (
              <p key={p} className="text-[#525353] text-sm md:text-base font-medium leading-6">
                {p}
              </p>
            ))}
          </div>
        ) : null}
      </div>

      {actions.length > 0 ? (
        <div className="w-full flex-1 flex items-center justify-center">
          <div className="w-full flex flex-col items-center gap-3">
            {actions.map((label, idx) => {
              const isPrimary = idx === actions.length - 1;
              return (
                <button
                  key={label}
                  type="button"
                  className={[
                    'h-[40px] w-[240px] md:w-[260px] px-4 py-2 rounded-lg border-2 text-sm font-semibold flex items-center justify-center gap-2',
                    isPrimary
                      ? 'bg-[#6ECFCF] border-[#6ECFCF] text-[#131315] hover:bg-[#069694] hover:border-[#069694]'
                      : 'bg-white border-[#939393] text-[#131315]',
                  ].join(' ')}
                >
                  <span>{label}</span>
                  {isPrimary ? <Download className="w-[18px] h-[18px]" /> : null}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}

      {onContactUs ? (
        <button type="button" onClick={onContactUs} className="hidden" aria-label="Contact us">
          <HeadsetHelp className="w-5 h-5" />
        </button>
      ) : null}
    </div>
  );
}

